module.exports = __webpack_public_path__ + "static/media/37.d6ee528d.png";